// DropdownAddMedio.jsx
import React from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/20/solid";
import { useEditor } from "../../../../../App.jsx";
import { Image, Upload } from "lucide-react";

const DropdownAddMedio = ({className}) => {
    const { stateEditor, setStateEditor } = useEditor();

    const handleAddMedioSVG = () => {
        setStateEditor((prevState) => ({
            ...prevState,
            editor: true,
            editorID: "add",
            editorType: "medios_svg_input",
        }));
    };

    const handleAddMedioImg = () => {
        setStateEditor((prevState) => ({
            ...prevState,
            editor: true,
            editorID: "add",
            editorType: "medios_img_input",
        }));
    };

    return (
        <div className={`dropdown dropdown-end z-30 ${className}`}>
            <label tabIndex={0} className="btn btn-sm btn-outline w-full z-0">
                <div className=" flex items-center">

                    <PlusIcon className="w-5 h-5" aria-hidden="true" />
                    Añadir
                    <ChevronDownIcon className="w-5 h-5" aria-hidden="true" />
                </div>
            </label>
            <ul
                tabIndex={0}
                className="dropdown-content menu p-2 shadow-lg shadow-black bg-base-100 rounded-box w-64 z-50"
            >
                <li>
                    <button
                        onClick={handleAddMedioSVG}
                        className="flex items-center gap-2"
                    >
                        <Upload className="w-4 h-4 mr-2"/>
                        Desde Archivo
                    </button>
                </li>
                <li>
                    <button
                        onClick={handleAddMedioImg}
                        className="flex items-center gap-2"
                    >
                        <Image className="w-4 h-4 mr-2"/>
                        Desde Imagen
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default DropdownAddMedio;
